<template>
    <div class="language-edit form-material" v-if="record">
      <h2>{{ isNewRecord ? 'Create Record' : 'Edit Record' }}</h2>
      <div class="row">
          <div class="form-group row">
            <div class="col-3">
              <label for="Reference">Reference</label>
              <input type="text" class="form-control" id="Reference" v-model="record.Reference" required>
            </div>
             <div class="col-3" >
                <label for="DaysToExpire">Days to Expire</label>
                <input type="text" class="form-control" id="DaysToExpire" v-model="record.DaysToExpire" required>
             </div>
          </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div class="btn-group" role="group">
            <button type="submit" class="btn btn-primary" @click="saveRecord" :disabled="!record.Reference && !record.DaysToExpire">Save</button>
            <button type="button" class="btn btn-secondary" @click="cancel">Exit</button>
            <button type="button" class="btn btn-danger" @click="deleteRecord" v-if="!isNewRecord">Delete</button>
          </div>
        </div>
      </div>
    </div>
    
  </template>
  
  <script>
  import RecordMixin from '@/components/tools/RecordMixin.vue';

  export default {
    name: 'BookingExpiredEdit',
    mixins: [RecordMixin],
    props: ['id'],
    data() {
      return {
        table: 'bookingexpired',
        isUploading: false,
        viewExtra: false,
        computedForm: null,
      };
    },
    methods: {

    }
  }
</script>

  
  <style scoped>
  .language-edit {
    margin: 0 auto;
    padding: 20px;
  }
  h3 {
    color: #2c3e50;
    margin-bottom: 15px;
  }

  h4 {
    color: #2c3e50;
    margin-bottom: 12px;
  }
  </style>